export const CurrentRouteInfo = (state) => {
  return {
    pathname: state.router.currentRoute.pathname,
    search: state.router.currentRoute.search,
    hash: state.router.currentRoute.hash
  }
}

export const IndexRoutes = (state) => {
  return state.router.indexRoutes
}
